<ng-container
  *ngComponentOutlet="layout | dynamicIdtComponentResolution: 'render' ndcDynamicInputs: {
    layout: layout
  };">
</ng-container>
